import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  createRef,
} from 'react';

import { Form, Radio, Button, Skeleton, Input, message, Modal, Popover } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons'
const FormItem = Form.Item;
import classnames from 'classnames';
import Container from '@/components/H5PC/Layout/Container/Container';
import OrderInfo from '@/components/H5PC/Components/OrderInfo/index';
import Card from '@/components/H5PC/Components/Card';
import UnionPay from '@/components/H5PC/Components/UnionPay';
import PIXBOL from '@/components/H5PC/Components/PIXBOL';
import Router from 'next/router';

import AlipayQrLink from '@/components/H5PC/Components/Alipay+/AlipayQrLink';


import LinkPay from '@/components/H5PC/Components/Alipay+/LinkPay'
import Evonet from '@/components/H5PC/Components/Evonet'


import { CommonError } from '@/components/H5PC/CommonMethod.js'

import myContext from '@/utils/createContext';
import { resCodeMsg } from '@/components/resCodeMsg';
import { riskCreateJs, getSessionId } from '@/components/Common/riskCreateJs';
import { getInitCardInfo, paymentPollingQuery, paymentResultQuery } from '@/components/H5PC/service';
import bankCardAttribution from '@/components/Common/bankCardOfChina.js';
import QueryString from 'query-string';
import { getUrlPrefix, getEnv, gtag, formatCardHolderIdNoVal, getPaymentData, isEmptyObject } from '@/utils/index';
import MessageModal from '@/components/H5PC/Components/MessageModal';
import NodeRSA from 'node-rsa';
import _ from 'lodash';
import LockLoading from '@/components/LockLoading/index';
import Tds from '@/components/H5PC/Components/Tds';
import { sessionStorage } from '@/utils'

import {
  CommonHandleSubmit,
  CommonHandleCancelPayment,
  CommonJudgePaymentStatus,
  CommonTestCode,
  paySuccussHref
} from '@/components/H5PC/CommonMethod';

const ALIPAY_TYPE = ['DANA', 'BPI', 'RABBIT_LINE_PAY', 'BOOST', 'ALIPAY_CN', 'ALIPAY_HK', 'GCASH', 'KAKAOPAY', 'TNG', 'TRUEMONEY']

function CreditCard(props) {
  const intl = props.intl;
  const { formatMessage } = intl;
  const containerRef = useRef(null);
  const addressRef = useRef();
  const btnRef = useRef()

  const { resData, isMobileView, key, cashierLastResponseCode, infoData } = useContext(myContext);
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  let [initData, setInitData] = useState({});
  const [redirectUrl, setRedirectUrl] = useState('')

  // 用于迅联支付的操作
  const [actionType, setActionType] = useState([])
  const [paymentLen, setPaymentLen] = useState('')
  const [showMore, setShowMore] = useState(false)
  const [orderStatus, setOrderStatus] = useState('')

  const [order, setOrder] = useState('')
  const [header, setHeader] = useState('')
  const [returnUrl, setReturnUrl] = useState('')

  const [method, setMethod] = useState('')

  const [body, setBody] = useState('')
  const [origin, setOrigin] = useState('')
  

  const cashierData = isEmptyObject(infoData) ? resData : infoData || {};

  let {
    payments,
    actualPaymentAmount,
    actualPaymentCurrency,
    email,
    lastResponseCode,
  } = cashierData;


  let paymentMethod = [];
  for (let i = 0; i < payments.length; i++) {
    if (payments[i].paymentMethod) {
      paymentMethod.push(payments[i].paymentMethod);
    }
  }


  // 初始化radio，根据后端返回的数据显示和隐藏payments
  // const myRadioValue = paymentMethod[0] && paymentMethod[0].toLowerCase();
  const [radioValue, setRadioValue] = useState(paymentMethod[0]);
  const [payflowRes, setPayflowRes] = useState({
    tdsInfo: { nextStep: 'DEVICE' },
  });
  // 类型这个字段很重要，千万别重名
  const [type, setType] = useState('');

  // 处理RSA验证失效
  var myToken = '', myPublicKey = '';

  // let type;

  useEffect(() => {
    const type = paymentMethod[0].toLowerCase();
    localStorage.setItem('paymentMethod', type)
    setType(type);

    // 隐藏显示逻辑
    if (paymentMethod.length === 1) {
      setRadioValue(paymentMethod[0]);
    }
    let newActionType = []
    // 判断第一种支付方式是否为迅联支付
    for (let i = 0; i < payments.length; i++) {
      if (payments[i]?.channelCodes?.[0].indexOf('EVO') != -1) {
        newActionType.push('EVO')
      } else { 
        newActionType.push('')
      }
    }
    setActionType(newActionType)
    if (payments.length > 5) { 
      setShowMore(false)
    }

    setPaymentLen(payments.length)

    // 获取跳转链接
    setOrigin(window?.location?.origin)

    //导入风控指纹js
    riskCreateJs();
  }, []);

  useEffect(() => {
    const type = paymentMethod[0].toLowerCase();

    fetchInitData(type, false);


    if (!isEmptyObject(resData)) {
      checkPaymentResult()
    }

  }, [resData])

  // 初始化收银台
  const fetchInitData = async (type, radioType) => {
    const urlPrefix = getUrlPrefix();

    let res = getPaymentData(type, radioType && !isEmptyObject(resData) ? resData : cashierData, resData);


    const redirectUrl = res && res.redirectUrl;
    if (redirectUrl) {
      if (redirectUrl.indexOf('http') > -1) {
        window.location.href = redirectUrl;
      } else {
        window.location.href = `${urlPrefix}${redirectUrl}`;
      }
    } else {

      getCardName(res && res.data, type)
      getCardNo(res && res.data, type)

      setInitData(res && res.data);

      // 计算页面加载完成时间
      const pageTime = new Date().getTime() - Number(localStorage.getItem('llPay_startTime'));

      if (!sessionStorage.getItem('pageTime')) {
        sessionStorage.setItem('pageTime', pageTime)
      }

      // 判断支付成功失败
      CommonJudgePaymentStatus(props, res && res.data, isMobileView);
    }
  };
  let cardName = '';

  const getCardName = (data, type) => {
    // 设置cardName
    let {
      cardName,
      cardFirstName,
      cardLastName,
    } = data || '';

    let name1 = ''; // name1 用来拼接cardFirstName, cardLastName， name2 用来做 firstName/lastName

    cardFirstName = cardFirstName ? cardFirstName : '';
    cardLastName = cardLastName ? cardLastName : '';

    if (cardFirstName || cardLastName) {
      name1 = cardFirstName.trim() + ' ' + cardLastName.trim(); // 去前后空格，然后拼接
    } else {
      name1 = '';
    }
    //  设置cardName ， 填充到input
    cardName = cardName || name1.trim() || cardLastName.trim() || cardFirstName.trim() || ''; // 移除前后空格

    if (type === "icr" || type === 'pix' || type === 'bol') {
      form.setFieldsValue({ cardName });
    } else {
      form.setFieldsValue({ cardName: '' });
    }
  }

  let cardHolderIdNo = '';

  const getCardNo = (data, type) => {
    let {
      cardHolderIdNo = ''
    } = data || {};
    if (type === 'pix' || type === 'bol') {
      form.setFieldsValue({
        cardHolderIdNo: formatCardHolderIdNoVal(cardHolderIdNo)
      });
    }
  }



  let {
    publicKey,
    token,
    actualPaymentCurrencySymbol,
    needBillingAddress, // 是否需要账单地址，如果为true就是需要传，false则不需要传，就隐藏Address组件模块
    showEuropeFlag,
    companyAddress,
    companyName,
    description,

  } = resData || {};

  let { 

    cardCountry,
    cardLine1,
    cardLine2,
    cardCity,
    cardState,
    cardPostcode,
    cardDistrict,
  } = initData || {}

  myToken = token;
  myPublicKey = publicKey;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [validateTrigger, setValidateTrigger] = useState('onSubmit'); // 默认为submit时候校验
  const [myLastResponseCode, setMyLastResponseCode] = useState(
    cashierLastResponseCode || lastResponseCode || '', // _.isEmpty的对数字判断为空；_.isEmpty(1111) ==> true,所以不能用于判断数字
  ); // 默认为submit时候校验


  // MessageModal组件中用到
  const [msgModalCardNo, setMsgModalCardNo] = useState('');
  const [msgModalPhoneNum, setMsgModalPhoneNum] = useState('');
  const [bankCode, setBankCode] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [validateKey, setValidateKey] = useState('');
  const [myActualPaymentAmount, setMyActualPaymentAmount] = useState('');
  const [
    myActualPaymentCurrencySymbol,
    setMyActualPaymentCurrencySymbol,
  ] = useState('');
  const [myActualPaymentCurrency, setMyActualPaymentCurrency] = useState('');

  useEffect(() => {
    if (validateTrigger === 'onChange') {
      // 更改错误提示的多语言
      form.validateFields();
    }
  }, [intl.locale]);
  /**
   * 支付
   *
   */
  const onFinish = async values => {

    if (!myPublicKey) {
      message.warning(formatMessage({ id: 'ga-checkout.netword-slow'}));
      return;
    }
    // console.log(values);
    // return;
    // 参数
    // console.log(values);
    let params = {};
    params = {
      ...values,
      key,
    };
    // 只有信用卡需要过期日期
    if (radioValue === 'ICR') {
      params.cardName = values.cardName && values.cardName.trim(); // 去除卡姓名前后空格
      params.cardExpirationMonth = values.cardExpiryDate.substr(0, 2);
      params.cardExpirationYear = '20' + values.cardExpiryDate.substr(3, 4);

      // 移除name中的0-9及特殊字符`,
      params.cardName = values.cardName && values.cardName.replace(/(\d|\`|\,)/g, '');
      // 若city全部为数字，则置为NULL
      const allNumberReg = /^[0-9]*$/;
      if (allNumberReg.test(values.cardCity)) {
        params.cardCity = 'NULL';
      }
      if (!Boolean(params.cardCvv) || params?.cardCvv === '***'){
				delete params['cardCvv'];
			}
    }
    if (radioValue === 'LCR') {
      params.cardName = values.cardName && values.cardName.trim(); // 去除卡姓名前后空格
      params.cardExpirationMonth = values.cardExpiryDate.substr(0, 2);
      params.cardExpirationYear = '20' + values.cardExpiryDate.substr(3, 4);
      params.cardHolderIdType = 'CPF'; // 巴西类型是CPF
      // 巴西指纹采集
      params.sessionId = sessionStorage.getItem('sessionId') || '';
    }

    if (radioValue === 'PIX' || radioValue === 'BOL') {
      const _length = values.cardHolderIdNo.replace(/[^0-9]/gi, '').length;
      params.cardHolderIdType = _length === 11 ? 'CPF' : 'CNPJ';
      params.cardCountry = values.cardCountry || cardCountry;
      params.cardCity = values.cardCity || cardCity;
      params.cardLine1 = values.cardLine1 || cardLine1;
      params.cardLine2 = values.cardLine2 || cardLine2;
      params.cardState = values.cardState || cardState;
      params.cardPostcode = values.cardPostcode || cardPostcode;
      params.cardDistrict = values.cardDistrict || cardDistrict;

      // 巴西指纹采集
      params.sessionId = sessionStorage.getItem('sessionId') || '';
    }

    if (radioValue === 'QPT') {
      // 调用国内银行正则表达式
      const bankInfo = bankCardAttribution(params.cardNo);
      const cardType = bankInfo?.cardType || ''; // 借记卡还是贷记卡(C或者D) 识别到就传正常值，识别不到就传空
      params.cardType = cardType;
      for (let i = 0; i < payments.length; i++) {
        if (payments[i].paymentMethod === 'QPT') {
          params.cardBrand = payments[i].cardBrands[0];
        }
      }
    }
    
    let type = radioValue.toLowerCase();

    if (ALIPAY_TYPE.indexOf(radioValue) != -1) {
      // 支付接口参数
      params = {
        terminalType: isMobileView ? 'WAP' : 'WEB',
        paymentType: radioValue.toLocaleLowerCase(),
      }
      type = 'offline'
    }
    // 卡号去除空格
    if(Boolean(values.cardNo)){
      params.cardNo = values.cardNo.replace(/\s*/g, '');
    }

    //风控指纹获取sessionId,和后端约定为riskDeviceId
    if (getSessionId()) {
      params.riskDeviceId = getSessionId();
    }

    // 加密
    const pubKey = new NodeRSA(myPublicKey, 'pkcs8-public');
    const newParams = JSON.parse(JSON.stringify(params));
    // 只有非生产才打印params参数
    if (getEnv() !== 'production') {
      console.log(getEnv() + 'params', params);
    }

    // return;

    pubKey.setOptions({
      encryptionScheme: 'pkcs1',
    }); // 必须得加，要和java加密解密统一
    const encrypted = pubKey.encrypt(newParams, 'base64');
    // 加密后的参数

    const paramsEncrypted = {
      encrypted,
      token: myToken,
    };
    setLoading(true);

    // 根据类型传支付type


    // 请求,并且动态获取code码来调整red
    // handleFormSubmit(key, paramsEncrypted);
    const res = await CommonHandleSubmit(
      props,
      key,
      paramsEncrypted,
      resData,
      setLoading,
      isMobileView,
      type,
    );

    if (res && (res.code === 600001 || res.code === 600002)) {
      const resNext = await getInitCardInfo(type, key);
      myToken = resNext && resNext.data && resNext.data.token;
      myPublicKey = resNext && resNext.data && resNext.data.publicKey

      onFinish(values)
    }

    if (radioValue === 'QPT') {
      // 短信弹出窗
      let validateKey = res?.data?.validateKey;
      let actualPaymentAmount = res?.data?.actualPaymentAmount;
      let actualPaymentCurrencySymbol = res?.data?.actualPaymentCurrencySymbol;
      let actualPaymentCurrency = res?.data?.actualPaymentCurrency;
      if (validateKey) {
        setLoading(false);
        setMsgModalCardNo(params.cardNo);
        setIsModalVisible(true);
        setValidateKey(validateKey);
        setMyActualPaymentAmount(actualPaymentAmount);
        setMyActualPaymentCurrencySymbol(actualPaymentCurrencySymbol);
        setMyActualPaymentCurrency(actualPaymentCurrency);
        const phoneNumber = form.getFieldValue('phoneNumber');
        setMsgModalPhoneNum(phoneNumber);
      }
    }
    if (res && res.code !== 200000) {
      setMyLastResponseCode(res.code);
    }

    if (res && res.code === 200000) {
      let validateKey = res?.data?.validateKey;
      // 银联支付，并且不需要返回validateKey就直接支付成功的情况
      // 如果支付方式为PIX、BOL，则跳转前端pix和bol页面
      if (res.data.paymentStatus === 'WP') {
        if ((radioValue === 'QPT' && !validateKey) || radioValue == 'ICR') {
          setPayflowRes(res);
        } else if (radioValue === 'PEZ' || radioValue === 'KBA' || radioValue === 'KON'
          || (ALIPAY_TYPE.indexOf(radioValue) != -1 && !isMobileView)
        ) {
          if (res.data.redirectUrl) {
            window.location.href = res.data.redirectUrl
          }
        } else if (ALIPAY_TYPE.indexOf(radioValue) != -1 && isMobileView) {
          // 如果返回的是链接，则需要跳转到in-payment页面轮询
          if (res.data.redirectUrl) {
            sessionStorage.setItem('fromLink', true)
            window.location.href = `${origin}/in-payment?key=${key}&fromLink=true&redirectLink=${encodeURIComponent(res.data.redirectUrl)}`
          }
        } else if (radioValue === 'PIX' || radioValue === 'BOL') {
          paySuccussHref(res.data.redirectUrl, res.data.invoiceId, resData, type, key, res);
        } else {
          checkPolling()
        }
      } else if (res.data.paymentStatus === 'PS' || res.data.paymentStatus === 'PP') {
        checkPolling()
      } else if (res.data.paymentStatus === 'PF') {
        let returnData = res.data;
        const useData = {
          code: returnData.declineCode || '',
          message: returnData.errorMessage || '',
          ...returnData
        }
        CommonError(props, isMobileView, setLoading, useData);
      }
    }
  };

  const onFinishFailed = values => {
    console.log('error values', values);
    // todo 调用Address,很关键，不然展开不了未填写的地址信息
    setAddressRefChange(addressRef);
    setValidateTrigger('onChange');
  };
  // 表单验证错误，弹出地址选择信息
  const setAddressRefChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.clickEdit();
    }
  };

  const onChangeRadio = e => {
    // setPayflowRes({ code: 1234 });
    console.log('radio checked', e.target.value);
    setRadioValue(e.target.value);
    const type = e.target.value.toLowerCase();
    localStorage.setItem('paymentMethod', type)
    setType(type);

    console.log('重新调用初始化数据');
    fetchInitData(type, true);


  };

  const submitForm = function () {
    setTimeout(function () {
      if (btnRef.current) {
        btnRef.current.click()
      }
    }, 1000)
  }


  const getForm = function () {
    // 动态生成表单数据
    // const order = { a: 'aa', b: 'bb' };
    // const header = { c: 'cc', d: 'dd' };
    let orderArray = []
    let bodyArray = []
    // for (let obj1 in order) {
    //   orderArray.push(obj1)
    // }
    for (let obj2 in body) {
      bodyArray.push(obj2)
    }
    let html = (
      <form
        action={returnUrl}
        // action="https://www.baidu.com"
        method={method}
        // encType="multipart/form-data"
        style={{ display: 'none' }}
      >
        {/* {orderArray.map(val => {
          return <input type="text" key={val} value={order[val]} name={val} />
        })} */}
        {bodyArray.map(val => {
          return <input type="text" key={val} value={body[val]} name={val} />
        })}
        <input type="submit" value="Submit" ref={btnRef} />
      </form>
    )
    return html
  }

  const checkPaymentResult = async () => {
    const res = await paymentResultQuery(key);
    if (res && res.data && res.code === 200000) {
      let order_status = res.data.paymentStatus

      setOrderStatus(order_status)
      // 支付成功或者失败，但是有返回商户的重定向地址
      if (order_status === 'PS') {
        Modal.warning({
          content: formatMessage({ id: 'ga-checkout.error-200100' }),
          okText: intl.formatMessage({ id: 'ga-checkout.got-it' }),
          onOk() {
            // 删除缓存
            sessionStorage.removeItem('number')
            sessionStorage.removeItem('method')
            sessionStorage.removeItem('date')
            sessionStorage.removeItem('name')
            if (res.data.returnUrl) {
              setReturnUrl(res.data.returnUrl)
              setBody(res.data.requestBody)
              setMethod(res.data.requestMethod)
              // 延时等待后跳转到成功页面
              setTimeout(() => {
                submitForm()
              }, 300)
              return;
            } else {
              Router.push('/success?errorCode=200100')
              return
            }
          }
        })
      }
    }
  }

  const checkPolling = async () => {
    const res = await paymentPollingQuery(key)

    if (res && res.data) {
      let order_status = res.data?.paymentStatus
      // 等待支付，轮询
      if (order_status === 'WP' || order_status === 'IN' || order_status === 'PP') {

        if (res.data.redirectUrl) {
          window.location.href = res.data?.redirectUrl
        } else { 
          checkPolling()
          return
        }
           
      }
      // 超时
      if (order_status === 'PE') {
        Router.push(`/fail?code=408001&trace_id=${res?.trace_id}`)
        return
      }
      // 支付成功或者失败，但是有返回商户的重定向地址
      if (order_status === 'PS' && res.data.returnUrl) {
        // 删除缓存
        sessionStorage.removeItem('number')
        sessionStorage.removeItem('method')
        sessionStorage.removeItem('date')
        sessionStorage.removeItem('name')
        // 删除缓存
        setReturnUrl(res.data.returnUrl)
        setBody(res.data.requestBody)
        setMethod(res.data.requestMethod)
        // 延时等待后跳转到成功页面
        setTimeout(() => {
          submitForm()
        }, 500)

      }
      // 支付成功，无返回商户的重定向地址
      if (order_status === 'PS' && !res.data.returnUrl) {
        // 删除缓存
        sessionStorage.removeItem('number')
        sessionStorage.removeItem('method')
        sessionStorage.removeItem('date')
        sessionStorage.removeItem('name')
        Router.push('/success')
        return
      }
      // 支付失败，无返回商户的重定向地址
      if (order_status === 'PF') {

        let returnData = res.data;
        const useData = {
          code: returnData?.declineCode || '',
          message: returnData.errorMessage,
          ...returnData
        }
        CommonError(props, isMobileView, setLoading, useData);
        // window.location.href = res.data.redirectUrl || `/fail`
        return
      } 
    } else if (res.code === 600020) {
      checkPolling()
      return
    } else {
      Router.push(`/fail?code=${res.code}&trace_id=${res?.trace_id}`)
    }
  }

  const bankList = function (item) {
    let bankType = [];
    for (let i = 0; i < payments.length; i++) {
      if (payments[i].paymentMethod === item) {
        bankType = payments[i].cardBrands;
      }
    }

    let html = (
      <div className={`h5-card-elements-list h5-card-elements-list-${item}`}>
        <div style={{ right: 0, position: 'relative', top: '-4px' }}>
          {!_.isEmpty(bankType) &&
            bankType.map((val, k) => {
              if (k < 3) {
                return getContainer(val);
              }
            })}
          {
            bankType?.length > 3 ? bankMore(bankType) : ''
          }
        </div>
      </div>
    );
    return html;
  };

  

  const bankMore = function (bankType) {
    const moreBank = bankType.slice(3)
    console.log(moreBank);
    return (
      <Popover content={
        <div className={ 'more-bank-logo'}>
          {bankMoreContent(moreBank)}
          </div>
      } title="" placement="topRight">
        <Button>+{ bankType.length - 3}</Button>
      </Popover>
    )
  }

  const bankMoreContent = function (moreBank) { 
    // return 1234567
    console.log(moreBank);
    return moreBank.map((val, k) => { 
      return getContainer(val)
    })
  }

  const getContainer = function (val) {
    const prefix = 'h5pc-card-paid-list-';
    const suffix = '-actived';
    const iconScale = 'h5pc-card-paid-icon-scale';
    const bankActived = prefix + val + suffix;
    return (
      <div
        className={classnames({
          [iconScale]: true,
          [bankActived]: true,
        })}
        key={val}
      ></div>
    );
  };

  // 公共的渲染方法
  const commonRender = (item, k) => {
    let html;
    if (
      (item === 'ICR' && radioValue === 'ICR') ||
      (item === 'LCR' && radioValue === 'LCR')
    ) {
      html = <Card cref={addressRef} />;
    }
    if (
      (item === 'PIX' && radioValue === 'PIX') ||
      (item === 'BOL' && radioValue === 'BOL')
    ) {
      /* pix 和 bolete公用方法 */
      html = <PIXBOL cref={addressRef} />;
    }

    if (item === 'TRUEMONEY' && radioValue === 'TRUEMONEY') {
      html = <AlipayQrLink cref={addressRef} />;
    }

    if (item === 'ALIPAY_CN' && radioValue === 'ALIPAY_CN') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'ALIPAY_HK' && radioValue === 'ALIPAY_HK') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'DANA' && radioValue === 'DANA' && actionType[k] != 'EVO') {
      html = <LinkPay cref={addressRef} />;
    }
    if (item === 'BOOST' && radioValue === 'BOOST' && actionType[k] != 'EVO') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'GCASH' && radioValue === 'GCASH') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'KAKAOPAY' && radioValue === 'KAKAOPAY' && actionType[k] != 'EVO') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'BPI' && radioValue === 'BPI') {
      html = <LinkPay cref={addressRef} />;
    }
    if (item === 'TNG' && radioValue === 'TNG' && actionType[k] != 'EVO') {
      html = <AlipayQrLink cref={addressRef} />;
    }
    if (item === 'RABBIT_LINE_PAY' && radioValue === 'RABBIT_LINE_PAY' && actionType[k] != 'EVO') {
      html = <LinkPay cref={addressRef} />;
    }
    // 迅联
    if (item === 'WECHATPAY' && radioValue === 'WECHATPAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }
    if (item === 'PROMPTPAY' && radioValue === 'PROMPTPAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }
    if (item === 'KRUNGSRIONLINE' && radioValue === 'KRUNGSRIONLINE' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'RABBIT_LINE_PAY' && radioValue === 'RABBIT_LINE_PAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'BUALUANGIBANKING' && radioValue === 'BUALUANGIBANKING' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'MAYBANK' && radioValue === 'MAYBANK' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'CIMBCLICKS' && radioValue === 'CIMBCLICKS' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'MCASH' && radioValue === 'MCASH' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'TNG' && radioValue === 'TNG' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'BOOST' && radioValue === 'BOOST' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'BNI' && radioValue === 'BNI' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'MANDIRI' && radioValue === 'MANDIRI' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'PERMATA' && radioValue === 'PERMATA' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'BRI' && radioValue === 'BRI' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'OVO' && radioValue === 'OVO' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'DANA' && radioValue === 'DANA' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'NOBUBANKQRIS' && radioValue === 'NOBUBANKQRIS' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'AKULAKU_PAYLATER' && radioValue === 'AKULAKU_PAYLATER' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'LINEPAY' && radioValue === 'LINEPAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'PAIDY' && radioValue === 'PAIDY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }

    if (item === 'PAYCO' && radioValue === 'PAYCO' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }
    if (item === 'NAVERPAY' && radioValue === 'NAVERPAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }
    if (item === 'KAKAOPAY' && radioValue === 'KAKAOPAY' && actionType[k] === 'EVO') {
      html = <Evonet cref={addressRef} />;
    }


    return (
      <>
        {html ? (
          <div className="h5pc-group-radio-content-container">
            <myContext.Provider
              value={{
                form,
                initData,
                cashierData,
                resData,
                radioValue,
                isMobileView,
                type,
                loading,
                actualPaymentAmount,
                actualPaymentCurrency,
                publicKey,
                setLoading,
                key,
                token,
                checkPolling,
                orderStatus,
              }}
            >
              {html}
            </myContext.Provider>
          </div>
        ) : null}
      </>
    );
  };

  let radioContainerRender = () => {
    // 如果只有一种支付方式，那么不显示radio
    let radioCheck =
      paymentMethod.length === 1 ? 'h5pc-group-radio-check-none' : '';
    return (
      <Radio.Group
        onChange={onChangeRadio}
        value={radioValue}
        className="h5pc-group-radio"
      >
        {paymentMethod.map((item, k) => {
          return (
            <div className={`h5pc-group-radio-f-container`} style={{
              display:
                paymentLen < 5 ? 'block' :
                  k < 5 ?
                    'block' :
                    showMore ?
                      'block'
                      :
                      'none'
            }} key={item} >
              <div className="h5pc-group-radio-container">
                <Radio
                  value={item}
                  className={classnames({
                    [radioCheck]: true,
                  })}
                >
                  <div className="h5pc-group-radio-container-title">
                    {item === 'QPT' ? 'UnionPay(Credit and Debit card)' : null}
                    {item === 'ICR'
                      ? formatMessage({ id: 'ga-checkout.please-with-card' })
                      : null}
                    {item === 'LCR'
                      ? formatMessage({ id: 'ga-checkout.credit-card' })
                      : null}
                    {item === 'PIX' ? 'PIX' : null}
                    {item === 'BOL' ? 'Boleto' : null}

                    {item === 'ALIPAY_CN' ? 'AlipayCN' : null}
                    {item === 'ALIPAY_HK' ? 'AlipayHK' : null}

                    {item === 'KAKAOPAY' ? 'Kakao Pay' : null}
                    {item === 'GCASH' ? 'Gcash' : null}
                    {item === 'DANA' ? 'DANA' : null}
                    {item === 'TRUEMONEY' ? 'TrueMoney' : null}
                    {item === 'RABBIT_LINE_PAY' ? 'Rabbit Line Pay' : null}
                    {item === 'BPI' ? 'BPI' : null}
                    {item === 'TNG' ? 'Touch n Go' : null}
                    {item === 'BOOST' ? 'BOOST' : null}
                    {/* 迅联 */}
                    {item === 'WECHATPAY' ? 'WeChat Pay' : null}
                    {item === 'PROMPTPAY' ? 'Prompt Pay' : null}
                    {item === 'KRUNGSRIONLINE' ? 'Krungsri Online' : null}
                    {item === 'BUALUANGIBANKING' ? 'Bualuang iBanking' : null}
                    {item === 'MAYBANK' ? 'Maybank' : null}
                    {item === 'CIMBCLICKS' ? 'CIMB Clicks' : null}
                    {item === 'MCASH' ? 'Mcash' : null}
                    {item === 'BNI' ? 'BNI' : null}
                    {item === 'MANDIRI' ? 'Mandiri' : null}
                    {item === 'PERMATA' ? 'Permata' : null}
                    {item === 'BRI' ? 'BRI' : null}
                    {item === 'OVO' ? 'OVO' : null}
                    {item === 'NOBUBANKQRIS' ? 'Nobu Bank QRIS' : null}
                    {item === 'AKULAKU_PAYLATER' ? 'Akulaku' : null}
                    {item === 'PAYCO' ? 'PAYCO' : null}
                    {item === 'NAVERPAY' ? 'Naver Pay' : null}
                    {item === 'PAIDY' ? 'Paidy' : null}
                    {item === 'LINEPAY' ? 'Line Pay' : null}
                  </div>
                  {item === 'PIX' || item === 'BOL' ? (
                    <div className="h5pc-group-radio-container-icon">
                      <div className="h5-card-elements-list">
                        <div style={{ right: 0 }}>
                          {/* <img
                            style={{ height: '18px' }}
                            src={`/static/images/${item.toLocaleLowerCase()}.png`}
                          ></img> */}
                          <div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
                        </div>
                      </div>
                    </div>
                  ) :
                    // 针对Alipay+的支付方式
                    [
                      'TRUEMONEY',
                      'ALIPAY_CN',
                      'ALIPAY_HK',
                      'DANA',
                      'GCASH',
                      'TNG',
                      'RABBIT_LINE_PAY',
                      'BPI',
                      'KAKAOPAY',
                      'BOOST'
                    ].includes(item) && actionType[k] != 'EVO' ? (
                      <div className="h5pc-group-radio-container-icon">
                        <div className="h5-card-elements-list">
                          <div style={{ right: 0, display: 'flex', alignItems: 'center' }}>
                            <div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
                            <span style={{ margin: '0px 0px 0px 10px' }}>|</span>
                            <div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-alipay-actived`}></div>
                          </div>
                        </div>
                      </div>
                      )
                      :
                      // 迅联支付方式
                      [
                        'WECHATPAY',
                        'PROMPTPAY',
                        'KRUNGSRIONLINE',
                        'RABBIT_LINE_PAY',
                        'BUALUANGIBANKING',
                        'MAYBANK',
                        'CIMBCLICKS',
                        'MCASH',
                        'TNG',
                        'BOOST',
                        'BNI',
                        'MANDIRI',
                        'PERMATA',
                        'BRI',
                        'OVO',
                        'DANA',
                        'NOBUBANKQRIS',
                        'AKULAKU_PAYLATER',
                        'LINEPAY',
                        'PAIDY',
                        'PAYCO',
                        'NAVERPAY',
                        'KAKAOPAY'
                      ].includes(item) && actionType[k] === 'EVO' ? (
                        <div className="h5pc-group-radio-container-icon">
                          <div className="h5-card-elements-list">
                            <div style={{ right: 0, display: 'flex', alignItems: 'center' }}>
                              <div className={`h5pc-card-paid-icon-scale h5pc-card-paid-list-${item.toLocaleLowerCase()}-actived`}></div>
                            </div>
                          </div>
                        </div>
                      )  : (
                      <div className="h5pc-group-radio-container-icon">
                        {bankList(item)}
                      </div>
                    )
                  }
                </Radio>
              </div>
              {item === 'QPT' && radioValue === 'QPT' ? (
                <div className="h5pc-group-radio-content-container">
                  <myContext.Provider
                    value={{
                      form,
                      initData,
                      bankCode,
                      setBankCode,
                      isMobileView,
                      resData
                    }}
                  >
                    <UnionPay />
                  </myContext.Provider>
                  <myContext.Provider
                    value={{
                      initData,
                      isMobileView,
                      key,
                      msgModalCardNo,
                      bankCode,
                      isModalVisible,
                      setIsModalVisible,
                      loading,
                      setLoading,
                      validateKey,
                      setValidateKey,
                      myActualPaymentAmount,
                      myActualPaymentCurrencySymbol,
                      myActualPaymentCurrency,
                      msgModalPhoneNum,
                    }}
                  >
                    <MessageModal />
                  </myContext.Provider>
                </div>
              ) : null}
              {/* 公共的渲染方法 */}
              {
              commonRender(item, k)
              }
            </div>
          );
        })}
      </Radio.Group>
    );
  };

  return (
    <Container>
      <div className="h5pc-cashier" ref={containerRef}>
        <div className="h5pc-cashier-logo-container">
          <div className="h5pc-cashier-logo-container-title">
            {/* Payment */}
            {formatMessage({ id: 'ga-checkout.payment' })}
          </div>
          {/* 取消支付，跳转到 cancelUrl */}
          {
            !isMobileView ?
              <div className="h5pc-cashier-logo-container-cancel">
                <span
                  onClick={() =>
                    CommonHandleCancelPayment(props, resData, key, isMobileView)
                  }
                >
                  {/* Cancel */}
                  {formatMessage({ id: 'ga-checkout.cancel' })}
                </span>
              </div>
              :
              ''
          }
        </div>
        <div className="h5pc-container-line"></div>
        {/* 错误提醒 */}
        {myLastResponseCode ? (
          <div className="h5pc-container-error">
            {resCodeMsg(props, myLastResponseCode)}
            {/* The available balance of the bank card is insufficient, please choose
          another method to complete the payment. */}
          </div>
        ) : null}
        <myContext.Provider value={cashierData}>
          <OrderInfo />
        </myContext.Provider>
        <div style={{ marginBottom: '10px' }}></div>
        {!_.isEmpty(initData) ? (
          <Form
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            validateTrigger={validateTrigger}
            requiredMark={false}
            layout="vertical"
            scrollToFirstError
            initialValues={{
              cardName,
              cardHolderIdNo: '',
              email,
              cardCountry,
              cardLine1,
              cardLine2,
              cardCity,
              cardState,
              cardPostcode
            }}
          >
            {loading ? <LockLoading msg="Processing..." /> : null}

            {radioContainerRender()}
            {
              !showMore && paymentLen > 5 ?
                <div style={{ textAlign: 'center' }}>
                  <Button
                    style={{ color: '#666', background: 'transparent' }}
                    type='text'
                    onClick={() => {
                    setShowMore(!showMore)
                  }}>
                    {formatMessage({ id: 'ga-checkout.more.payment' })}
                    <DownOutlined />
                  </Button>
                </div>
                :
                ''
            }
            

            {showEuropeFlag ? (
              <div>
                <div className="company-name">{companyName}</div>
                <div className="company-address">{companyAddress}</div>
              </div>
            ) : null}
          </Form>
        ) : (
          <div
            style={{
              padding: '0 15px',
              background: '#fff',
              margin: '0 15px',
            }}
          >
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}
      </div>
      {/*  ----- 风控指纹相关以及页面跳转开始---- */}
      <myContext.Provider
        value={{
          isMobileView,
          key,
          payflowRes,
          resData,
          type,
          setLoading,
          checkPolling
        }}
      >
        <Tds />
      </myContext.Provider>
      {returnUrl ? getForm() : ''}
      {/*  ----- 风控指纹相关以及页面跳转结束 ---- */}
    </Container>
  );
}

export default injectIntl(CreditCard);
